// extracted by mini-css-extract-plugin
module.exports = {"search_wrapper":"SearchBox_search_wrapper__1Mhph","search_info":"SearchBox_search_info__1vZ4k"};